
import { Component, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { generalService } from '../services/general.service';
import { Familiar } from '../models/familiar';
import { MatPaginator,MatDialog, MatSort } from '@angular/material';
import { DataService } from '../utils/data.service';
import { FamiliarAddEditComponent } from '../familiar/agregar-editar/familiarAddEdit.component';
import { DataSourceGrid } from '../utils/data-source-grid.component';
@Component({
  selector: 'my-familiar',
  styleUrls: [],
  templateUrl: 'Familiar.component.html',
  providers: [generalService]
})


 export class FamiliarComponent implements OnInit {
titulo = '';

public datosFamiliar:any[];
 public familiar: Familiar;
  displayedColumns = ['acciones', 'nombre', 'relacion' , 'fecha'];
  dataSource: DataSourceGrid | null;
person_id: string;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private _generalService: generalService,
    public dataService: DataService,
    public dialog: MatDialog
    ) {
     this.familiar = new Familiar();
     this.person_id = (this.route.snapshot.paramMap.get('id'));
    // this.person_id = "1";
     this.datosFamiliar = new Array();
    // Usar en caso de emergencia con el router
    // this.router.events.subscribe(path => {
    //   console.log('path = ', path);
    // });
  }

  ngOnInit() {

    this.getFamiliares(this.person_id);
    }

 @ViewChild(MatPaginator) paginator: MatPaginator;
 @ViewChild(MatSort) sort: MatSort;

    getFamiliares(id: any) {

      this._generalService.metodoCall(`familiar/consultarFamiliares/${id}`).subscribe(
        (result) => {

          this.datosFamiliar = JSON.parse(result);
          this.dataSource = new DataSourceGrid(this.datosFamiliar, this.paginator, this.sort);
          if (this.datosFamiliar.length <= 0) {
            $('#tableFamiliar .mat-row').remove('.mat-row');
          }
        },
        (error) => {
          let errorMsj =  error as any;
          console.log(errorMsj);
        }
      );
    }

     agregar() {
    this.dataService.tipo = 'agregar';
    const dialogRef = this.dialog.open(FamiliarAddEditComponent, {disableClose: true});
    this.dataService.idPersonal = this.person_id;
    this.dataService.dialogRef = dialogRef;
    dialogRef.afterClosed().subscribe((result) => {
      if (this.dataService.guardado) {
        this._generalService.toastCall('El registro se agregó exitosamente!');
        this.ngOnInit();
      }
    });
  }

   editar(idFamiliar) {
    this.dataService.id = idFamiliar;
    this.dataService.tipo = 'editar';
    this.dataService.idPersonal = this.person_id;
    const dialogRef = this.dialog.open(FamiliarAddEditComponent, {disableClose: true});
    this.dataService.dialogRef = dialogRef;
    dialogRef.afterClosed().subscribe((result) => {
      if (this.dataService.guardado) {
        this._generalService.toastCall('El registro se modificó exitosamente!');
        this.ngOnInit();
      }
    });
  }

    eliminarConfirm(data: any) {
    this.familiar.idFamilar = data.idFamiliar;
    const eliminarHttp = new EventEmitter<any>();
    eliminarHttp.subscribe(
      (response: any) => {
        this._generalService.toastCall('El registro se eliminó exitosamente!');
        this.ngOnInit();

      }
    );
    this._generalService.modal(eliminarHttp, 'confirm', '¿Desea eliminar el familiar ' + data.nombre + '?', 'familiar/eliminarFamiliar/', this.familiar);
  }
}

  // llenado de grid

/*export interface familiarData {
   idFamilar:number,
    nombre:string,
     paterno:string,
     materno:string,
     relacion:number,
     accion: number,
     nombreP: string,
     apellidoP: string
}

export class DataSourceGrid extends DataSource<any> {
  constructor(private result, private _paginator: MatPaginator, public _sort: MatSort) {
    super();
  }

  connect(): Observable<familiarData[]> {
    const displayDataChanges = [
      this.result,
      this._sort.sortChange,
      this._paginator.page,
    ];

    return Observable.merge(...displayDataChanges).map(() => {
      const data = this.result.slice();
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      const sortedData = this.sortData(data.slice());
      return sortedData.splice(startIndex, this._paginator.pageSize);
    });
  }

  disconnect() {}

  sortData(data: familiarData[]): familiarData[] {
    if (!this._sort.active || this._sort.direction == '') { return data; }
    return data.sort((a, b) => {
      let propertyA: number|string = '';
      let propertyB: number|string = '';
      [propertyA, propertyB] = [a[this._sort.active], b[this._sort.active]];
      let valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      let valueB = isNaN(+propertyB) ? propertyB : +propertyB;
      return (valueA < valueB ? -1 : 1) * (this._sort.direction == 'asc' ? 1 : -1);
    });
  }

}*/



// WEBPACK FOOTER //
// ./src/app/familiar/familiar.component.ts